import clsx from "clsx"
import TieupImg from "src/components/common/TieupImg"
import { SizeType } from "../../common/TieupImg/SizeType"
import Link from "next/link"
import React from "react"
import routes from "../../../../routes"
import styles from "./index.module.scss"

export type FinishReadingDialogProps = {
  showEndZone: boolean
  novelistDisplayName: string
  novelistIcon: string
  handleOpenEndZone: () => void
  handleCloseEndZone: () => void
}

const FinishReadingDialog: React.FC<FinishReadingDialogProps> = ({
  showEndZone,
  novelistDisplayName,
  novelistIcon,
  handleOpenEndZone,
  handleCloseEndZone,
}) => {
  return (
    <>
      <div className={styles.endClickArea} onClick={handleOpenEndZone}></div>
      <div
        className={clsx([styles.endZone, showEndZone && styles.showEndZone])}
      >
        <div className={styles.closeButton}>
          <button
            onClick={handleCloseEndZone}
            className={"p-creatorMypage-header-icon -back"}
          ></button>
        </div>
        <div className={clsx([styles.endZoneInner, styles.notTieup])}>
          <p>
            おもしろかったら
            <br />
            たいあっぷ申請をしてみよう！
          </p>
          <Link href={routes.creatorUser(novelistDisplayName)}>
            <a className="c-button-secondary">
              <TieupImg src={novelistIcon} size={SizeType.s}></TieupImg>
              作者のページへ
            </a>
          </Link>
        </div>
      </div>
    </>
  )
}

export default FinishReadingDialog
